import { paths } from 'router/paths';

function useRoutePaths() {
  return paths;
}

export default useRoutePaths;
